import { FC } from 'react';
import { Box, Typography } from '@mui/material';

const Unauthorized_404: FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="background.default"
    >
      <Typography variant="h1" component="h1">
        404
      </Typography>
    </Box>
  );
};

export default Unauthorized_404;
